import "./RaicheSignUpContainer.scss"

export default function RaicheSignUpContainer({children, className}) {
    return (
        <section className={`${"layout"} ${className}`}>
            {children}
        </section>
    )
}